import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Library from "@/components/Library";
import GrammarTeaser from "@/components/GrammarTeaser";
import Testimonials from "@/components/Testimonials";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.to;
    if (!target) return undefined;
    const t = setTimeout(() => {
      document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState({}, "");
    }, 350);
    return () => clearTimeout(t);
  }, [location.state]);

  return (
    <div className="min-h-screen bg-navy-900" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Library />
        <GrammarTeaser />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
